<template>
  <MainPageBlockWrapperNew title="Наши партнеры" href="/our-partners">
    <div>
      <ClientOnly>
        <Swiper
          :slides-per-view="1"
          :space-between="20"
          :breakpoints="breakpoints"
          @swiper="onSwiper"
        >
          <SwiperSlide v-for="(item, index) in data" :key="item.id || index">
            <MainPageCardsReworkedBaseCard
              :data="item"
              :title-length="85"
              disable-announce
              disable-label
              disable-title
            />
          </SwiperSlide>
        </Swiper>
      </ClientOnly>
    </div>

    <SlidersSliderControl
      type="prev"
      class="absolute left-[-16px] top-45% z-10 hidden md:block"
      :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
      @click="slidePrev()"
    />
    <SlidersSliderControl
      type="next"
      class="absolute right-[-16px] top-45% z-10 hidden md:block"
      :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
      @click="slideNext()"
    />
  </MainPageBlockWrapperNew>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';
defineProps({
  data: {
    type: Array,
    default: () => [],
  },
});

const { onSwiper, slideNext, slidePrev, isEnd, isBeginning } = useSwiper();

const breakpoints = {
  1024: {
    slidesPerView: 2,
  },
  1280: {
    slidesPerView: 3,
  },
};
</script>
